import { render } from "./SubassembliesWindow.vue?vue&type=template&id=59483bd7"
import script from "./SubassembliesWindow.vue?vue&type=script&lang=js"
export * from "./SubassembliesWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__